import { defineCommands, type CommandsOf } from './defineCommands';
import type { CanvasStoreContext } from '../types';

export const canvasCommands = defineCommands({
  'canvas.rename': (ctx: CanvasStoreContext, event: { name: string }): CanvasStoreContext => ({
    ...ctx,
    canvas: { ...ctx.canvas, name: event.name },
  }),

  'canvas.setRotation': (ctx: CanvasStoreContext, event: { rotation: number }): CanvasStoreContext => ({
    ...ctx,
    canvas: { ...ctx.canvas, rotation: event.rotation },
  }),
});

export type CanvasMetaCommand = CommandsOf<typeof canvasCommands>;
